import { HorizontalSafeAreaContainer } from '../../../../../../components';
import { GiftCardConfirmationScreen } from '../../../../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return (
    <HorizontalSafeAreaContainer>
      <GiftCardConfirmationScreen />
    </HorizontalSafeAreaContainer>
  );
}
